export default [
  {
    id: 1,
    avatar: "",
    name: "Vansh Saini", // Member Name
    role: "Social Media Strategist", // Member Role
    projectName: "Sky Grid",         // Project Name
    projectRole: "Worked Desk 1",    // Project Role
    action: "Add",
    changedByavatar: 'https://i.pravatar.cc/150?img=12', 
    changedByName: 'Raj Patel',
    changedByRole: 'Product Manager',
    changedAt: '11:32 am',
    dateDay: 'Wed, Mar 5, 2025',
    time: '8:00 am - 9:00 am',
    timeChange: '01:00:00', 
  },
  {
    id: 2,
    avatar: "https://i.pravatar.cc/150?img=3",
    name: "Ansh Jain",
    role: "UI/UX Designer",
    projectName: "Project Quantum",
    projectRole: "Research Lead",
    action: "Delete",
    changedByavatar: 'https://i.pravatar.cc/150?img=13', 
    changedByName: 'Raj Patel',
    changedByRole: 'Product Manager',
    changedAt: '11:32 am',
    dateDay: 'Wed, Mar 5, 2025',
    time: '8:00 am - 9:00 am',
    timeChange: '01:00:00', 
  },
  {
    id: 3,
    avatar: "https://i.pravatar.cc/150?img=4",
    name: "Vansh Saini", // Member Name
    role: "Social Media Strategist", // Member Role
    projectName: "Mission Eclipse",         // Project Name
    projectRole: "Worked Desk 1",    // Project Role
   action: "Delete",
    changedByavatar: 'https://i.pravatar.cc/150?img=14', 
    changedByName: 'Raj Patel',
    changedByRole: 'UX Designer',
    changedAt: '11:32 am',
    dateDay: 'Wed, Mar 5, 2025',
    time: '8:00 am - 9:00 am',
    timeChange: '01:00:00', 
  },
  {
    id: 4,
    avatar: "https://i.pravatar.cc/150?img=5",
    name: "Emily Chen",
    role: "UI/UX Designer",
    projectName: 'Creative Boost',
    projectRole: 'Research Lead',
    action: 'Delete',
    changedByavatar: 'https://i.pravatar.cc/150?img=15', 
    changedByName: 'Raj Patel',
    changedByRole: 'Social Media Strategist',
    changedAt: '11:32 am',
    dateDay: 'Wed, Mar 5, 2025',
    time: '8:00 am - 9:00 am',
    timeChange: '01:00:00', 
  }
];
